import { VStack, Text, Pressable } from '@gluestack-ui/themed';
import { BottomBarItemProps } from './types';
import { Icon } from '@repo/core/components/core/Icon';
import { IconNames } from '@repo/core/components/core/Icon/types';

export const BottomBarItem = ({
  icon,
  label,
  isSelected,
  onPress
}: BottomBarItemProps) => {
  const fontColor = isSelected ? '$primary700' : '$textLight600';

  return (
    <Pressable onPress={onPress} variant="ghost" w="$full" flex={1}>
      <VStack
        w="$full"
        h="$full"
        alignItems="center"
        justifyContent="center"
        gap="$1"
        p="$2"
      >
        <VStack alignItems="center" justifyContent="center">
          <Icon
            name={icon as IconNames}
            size="2sm"
            color={fontColor}
            variant={isSelected ? 'solid' : 'regular'}
          />
        </VStack>

        <Text color={fontColor} textAlign="center" size="2xs" fontWeight={500}>
          {label}
        </Text>
      </VStack>
    </Pressable>
  );
};
